'use client';

import React, { useState } from 'react';

interface Props {
  customerName: string;
  customerWhatsapp: string;
  customerNotes: string;
  onSubmit: (name: string, whatsapp: string, notes: string) => void;
  onBack: () => void;
}

export default function AgendarStepCustomer({ customerName, customerWhatsapp, customerNotes, onSubmit, onBack }: Props) {
  const [name, setName] = useState(customerName);
  const [whatsapp, setWhatsapp] = useState(customerWhatsapp);
  const [notes, setNotes] = useState(customerNotes);
  const [errors, setErrors] = useState<{ name?: string; whatsapp?: string }>({});

  const validate = () => {
    const e: { name?: string; whatsapp?: string } = {};
    if (!name.trim()) e.name = 'Por favor, insira o seu nome.';
    if (!whatsapp.trim()) e.whatsapp = 'Por favor, insira o seu número de WhatsApp.';
    else if (!/^\+?[\d\s\-()]{8,}$/.test(whatsapp.trim())) e.whatsapp = 'Número inválido.';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) onSubmit(name.trim(), whatsapp.trim(), notes.trim());
  };

  return (
    <div className="space-y-8">
      <div>
        <span className="gold-line mb-4 block" />
        <h2 className="font-serif text-3xl lg:text-4xl font-light text-dark-brown mb-2">
          Os seus dados
        </h2>
        <p className="text-sm text-foreground/60">Para confirmar a sua marcação, precisamos de alguns dados.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Name */}
        <div>
          <label className="block text-xs tracking-[0.1em] uppercase font-semibold text-foreground/60 mb-2">
            Nome completo <span className="text-burnt-rose">*</span>
          </label>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="O seu nome"
            className={`w-full px-4 py-3.5 rounded-xl border bg-white text-sm text-foreground placeholder:text-foreground/30 focus:outline-none focus:ring-2 focus:ring-burnt-rose/30 transition-all ${
              errors.name ? 'border-danger' : 'border-border focus:border-burnt-rose'
            }`}
          />
          {errors.name && <p className="text-xs text-danger mt-1.5">{errors.name}</p>}
        </div>

        {/* WhatsApp */}
        <div>
          <label className="block text-xs tracking-[0.1em] uppercase font-semibold text-foreground/60 mb-2">
            Telefone / WhatsApp <span className="text-burnt-rose">*</span>
          </label>
          <input
            type="tel"
            value={whatsapp}
            onChange={e => setWhatsapp(e.target.value)}
            placeholder="+258 8X XXX XXXX"
            className={`w-full px-4 py-3.5 rounded-xl border bg-white text-sm text-foreground placeholder:text-foreground/30 focus:outline-none focus:ring-2 focus:ring-burnt-rose/30 transition-all ${
              errors.whatsapp ? 'border-danger' : 'border-border focus:border-burnt-rose'
            }`}
          />
          {errors.whatsapp && <p className="text-xs text-danger mt-1.5">{errors.whatsapp}</p>}
        </div>

        {/* Notes */}
        <div>
          <label className="block text-xs tracking-[0.1em] uppercase font-semibold text-foreground/60 mb-2">
            Observações <span className="text-foreground/30">(opcional)</span>
          </label>
          <textarea
            value={notes}
            onChange={e => setNotes(e.target.value)}
            placeholder="Pele sensível, primeira vez, etc."
            rows={3}
            className="w-full px-4 py-3.5 rounded-xl border border-border bg-white text-sm text-foreground placeholder:text-foreground/30 focus:outline-none focus:ring-2 focus:ring-burnt-rose/30 focus:border-burnt-rose transition-all resize-none"
          />
        </div>

        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={onBack}
            className="flex-1 py-4 rounded-full border-2 border-border text-sm font-semibold tracking-wide uppercase text-foreground/60 hover:border-burnt-rose hover:text-burnt-rose transition-all duration-200"
          >
            Voltar
          </button>
          <button
            type="submit"
            className="flex-grow-[2] py-4 rounded-full btn-primary font-semibold text-sm tracking-[0.1em] uppercase"
          >
            Rever Marcação
          </button>
        </div>
      </form>
    </div>
  );
}
